import React, { useState, useEffect, useRef } from "react";
import styles from "../../css/cashFlowTable.module.css";
import { getDisclosureOptions, getTemplateDetailsApiHandler, setDisclosureCellFormula, deleteDisclosureCellFormula ,
 getCashflowOptions,
 setCashflowCellFormula, setCashflow, deleteCashflow, deleteCashflowCellFormula,
 getPopulateFSDetailsApiHandler, setSocieCellFormula, deleteSocieCellFormula,
 getPopulateFSFormulaOptions,  setStandaloneCashflowWorkingsCellFormula,
 setStandaloneCashflowCellFormula, setStandaloneSocieCellFormula, setStandaloneDisclosureCellFormula,
 deleteStandaloneDisclosureCellFormula,
 deleteStandaloneCashflowWorkingsCellFormula,
 deleteStandaloneCashflowCellFormula,
 deleteStandaloneSocieCellFormula,
 getFormulaOptions,
 
} from "../../../WorkSpace/Components/ApiServices/apiHandler";
import { ReactComponent as DownArrow } from "../../assets/icons/down_arrow.svg";
import { ReactComponent as AddIcon } from "../../assets/icons/addEcl.svg";
import Swal from "sweetalert";
import DeletePopup from "../../elements/DeletePopup";
import { Tooltip } from "../../elements/Tooltip";
import { ReactComponent as DeleteGreyIcon } from "../../assets/icons/deleteGrey.svg";
import { ReactComponent as DeleteIcon } from "../../assets/icons/delete_red.svg";
import { ReactComponent as RemoveIcon } from "../../assets/icons/close_grey.svg";
import { TbPlus, TbMinus, TbX, TbDivide } from "react-icons/tb";

const OPERATORS = ["＋", "－", "×", "÷"];

const OperatorIcon = ({ type, size = 18 }) => {
  switch(type) {
    case "＋":
    case "+": return <TbPlus size={size} />;
    case "－":
    case "-": return <TbMinus size={size} />;
    case "×":
    case "*": return <TbX size={size} />;
    case "÷":
    case "/": return <TbDivide size={size} />;
    default: return <TbPlus size={size} />;
  }
};

const OPERATOR_MAP = {
  "＋": "+",
  "－": "-",
  "×": "*",
  "÷": "/",
};

// ── Dropdown: pass label=undefined to hide label ─────────────────────────
const Dropdown = ({ label, placeholder, options, value, onChange, initiallyOpen = false }) => {
  const [open, setOpen] = useState(initiallyOpen);
  const [search, setSearch] = useState("");
  const ref = useRef();
  const inputRef = useRef();
  const activeItemRef = useRef(null);
  const menuRef = useRef(null);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
        if (search === "") {
          onChange && onChange("");
        } else {
          setSearch(value || "");
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [search, value, onChange]);

  // Sync search with value when closed
  useEffect(() => {
    if (!open) setSearch(value || "");
  }, [value, open]);

  // Sync open state when initiallyOpen changes
  useEffect(() => {
    if (initiallyOpen) {
      setOpen(true);
    }
  }, [initiallyOpen]);

  // Scroll active item into view when opened
  useEffect(() => {
    if (open && activeItemRef.current) {
      activeItemRef.current.scrollIntoView({ block: "nearest", behavior: "auto" });
    }
  }, [open]);

  useEffect(() => {
    setHighlightedIndex(-1);
  }, [search, open]);

  useEffect(() => {
    if (highlightedIndex >= 0 && menuRef.current) {
      const activeEl = menuRef.current.children[highlightedIndex];
      if (activeEl) {
        activeEl.scrollIntoView({
          block: "nearest",
        });
      }
    }
  }, [highlightedIndex]);

  const filtered = options.filter((opt) =>
    opt.toLowerCase().includes(search.toLowerCase())
  );

  const handleKeyDown = (e) => {
    if (!open) {
      if (e.key === "ArrowDown" || e.key === "ArrowUp" || e.key === "Enter") {
        setOpen(true);
        setHighlightedIndex(0);
        e.preventDefault();
      }
      return;
    }

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) => {
        if (prev < 0) return 0;
        const nextIndex = prev + 1;
        return nextIndex < filtered.length ? nextIndex : 0;
      });
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((prev) => {
        if (prev <= 0) return filtered.length - 1;
        return prev - 1;
      });
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (highlightedIndex >= 0 && highlightedIndex < filtered.length) {
        const opt = filtered[highlightedIndex];
        onChange && onChange(opt);
        setOpen(false);
        setSearch("");
      } else if (filtered.length > 0) {
        const opt = filtered[0];
        onChange && onChange(opt);
        setOpen(false);
        setSearch("");
      }
    } else if (e.key === "Escape") {
      setOpen(false);
      setSearch("");
    }
  };

  return (
    <div
      ref={ref}
      className={styles.field}
      style={{ marginBottom: "5px" }}
      onKeyDown={handleKeyDown}
    >
      {label && <label>{label}</label>}
      <div className={styles.dropdown} style={{ display: "flex", alignItems: "center", padding: 0 }}>
        <input
          ref={inputRef}
          className={styles.dropdownInput}
          value={open ? search : (value || "")}
          placeholder={placeholder}
          title={value || ""}
          onChange={(e) => {
            const val = e.target.value;
            setSearch(val);
            setOpen(true);
            if (val === "") {
              onChange && onChange("");
            }
          }}
          onFocus={() => {
            setSearch("");
            setOpen(true);
          }}
          style={{
            flex: 1,
            border: "none",
            outline: "none",
            background: "transparent",
            padding: "0 8px",
            fontSize: "inherit",
            color: value ? "inherit" : "#999",
            cursor: "text",
            minWidth: 0,
            height: "35px",
            whiteSpace: "nowrap",
          }}
        />
        <span
          className={styles.arrow}
          onMouseDown={(e) => {
            e.preventDefault(); 
            setOpen((o) => {
              if (!o) setSearch("");
              return !o;
            });
          }}
          style={{
            cursor: "pointer",
            padding: "0 8px",
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s ease",
          }}
        >
          <DownArrow />
        </span>
      </div>
      {open && (
        <div className={styles.dropdownMenu} ref={menuRef}>
          {filtered.length > 0 ? (
            filtered.map((opt, i) => (
              <div
                key={i}
                title={opt}
                ref={value === opt ? activeItemRef : null}
                className={`${styles.dropdownItem} ${value === opt ? styles.activeItem : ""}`}
                style={{
                  backgroundColor: value === opt ? "#f4faf5" : highlightedIndex === i ? "#f8f9f9" : undefined,
                  fontWeight: value === opt ? "500" : undefined,
                }}
                onMouseDown={(e) => {
                  e.preventDefault();
                  onChange && onChange(opt);
                  setOpen(false);
                  setSearch("");
                }}
              >
                {opt}
              </div>
            ))
          ) : (
            <div className={styles.dropdownItem} style={{ color: "#999", pointerEvents: "none" }}>
              No results
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const OperatorBtn = ({ value, onChange, isModifier = false }) => {
  const [open, setOpen] = useState(false);

  return (
    <div style={{ position: "relative", display: "flex", flexDirection: "column", alignItems: "center", flexShrink: 0 }}>
      {open && (
        <div className={styles.operatorPopup} style={{ position: "absolute", bottom: "-70px", left: "50%", transform: "translateX(-50%)", zIndex: 99 }}>
          {OPERATORS.map((op) => (
            <div
              key={op}
              className={`${styles.operatorItem} ${value === op ? styles.activeOperator : ""}`}
              onClick={() => { onChange(op); setOpen(false); }}
            >
              <OperatorIcon type={op} size={18} />
            </div>
          ))}
        </div>
      )}
      <div
        style={{ display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}  
        className={isModifier ? styles.modifierMultiply : styles.addBtn}
        onClick={() => setOpen((o) => !o)}
        title="Change operator"
      >
        <OperatorIcon type={value} size={16} />
      </div>
    </div>
  );
};

// ── LinkedCellBlock ───────────────────────────────────────────────────────
const LinkedCellBlock = ({
  elKey,
  openSections,
  setOpenSections,
  modifiers,
  addModifier,
  updateModifierOperator,
  updateModifierValue,
  selections,
  setSelection,
  isFormula,
  moduleOpts = [],
  getSections,
  getSubSections,
  getCols,
  getRows,
  showLabels = false,
  showAddModifier = false,
  removeModifier,
  updateModifierType,
  isPrefilled = false,
}) => {
  const [showAllMods, setShowAllMods] = useState(false);
  const modifierRef = useRef(null);

  useEffect(() => {
    if (!showAllMods) return;
    const handleClickOutside = (event) => {
      if (modifierRef.current && !modifierRef.current.contains(event.target)) {
        setShowAllMods(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showAllMods]);

  const toggle = (sec) => {
    setOpenSections((prev) => {
      let isOpen;
      if (sec.endsWith("-module")) {
        isOpen = prev[sec] === undefined ? isPrefilled : prev[sec] === sec;
      } else {
        isOpen = prev[sec] === sec;
      }
      return {
        ...prev,
        [`${elKey}-module`]: "",
        [`${elKey}-cell`]: "",
        [sec]: isOpen ? "" : sec,
      };
    });
  };

  const col = selections[`${elKey}-col`];
  const row = selections[`${elKey}-row`];
  const mods = modifiers[elKey] || [];
  const hasModifiers = mods.length > 0;
  const isModBlock = elKey.startsWith("mod-");

  const isModuleOpen = openSections[`${elKey}-module`] === undefined ? isPrefilled : openSections[`${elKey}-module`] === `${elKey}-module`;

  return (
    <div className={styles.blockContent} ref={modifierRef}>
      <div className={styles.topContainer}>
        <div className={`${styles.headerGroup} ${(!hasModifiers && !isModBlock) ? styles.noInnerBorder : ""}`}>
          <div className={styles.sectionHeader} onClick={() => toggle(`${elKey}-module`)}>
            <span>Select Module</span>
            <DownArrow
              className={styles.arrowIcon}
              style={{
                transform: isModuleOpen ? "rotate(180deg)" : "rotate(0deg)",
              }}
            />
          </div>
          {isModuleOpen && (
            <div className={styles.sectionBody}>
              <Dropdown
                label={showLabels ? "Select Module" : undefined}
                placeholder="Select module"
                options={moduleOpts}
                value={selections[`${elKey}-mod`]}
                onChange={(v) => {
                  setSelection(`${elKey}-mod`, v);
                  setSelection(`${elKey}-sec`, "");
                  setSelection(`${elKey}-sub`, "");
                  setSelection(`${elKey}-col`, "");
                  setSelection(`${elKey}-row`, "");
                }}
              />
              <Dropdown
                label={showLabels ? "Select Section" : undefined}
                placeholder="Select section"
                options={getSections(selections[`${elKey}-mod`])}
                value={selections[`${elKey}-sec`]}
                onChange={(v) => {
                  setSelection(`${elKey}-sec`, v);
                  setSelection(`${elKey}-sub`, "");
                  setSelection(`${elKey}-col`, "");
                  setSelection(`${elKey}-row`, "");
                }}
              />
              <Dropdown
                label={showLabels ? "Select Sub-Section" : undefined}
                placeholder="Select sub-section"
                options={getSubSections(selections[`${elKey}-mod`], selections[`${elKey}-sec`])}
                value={selections[`${elKey}-sub`]}
                onChange={(v) => {
                  setSelection(`${elKey}-sub`, v);
                  setSelection(`${elKey}-col`, "");
                  setSelection(`${elKey}-row`, "");
                }}
              />
            </div>
          )}

          <div className={styles.sectionHeader} onClick={() => toggle(`${elKey}-cell`)}>
            <span>Select Cell</span>
            <DownArrow
              className={styles.arrowIcon}
              style={{
                transform: openSections[`${elKey}-cell`] ? "rotate(180deg)" : "rotate(0deg)",
              }}
            />
          </div>
          {openSections[`${elKey}-cell`] && (
            <div className={styles.sectionBody}>
              {isFormula ? (
                <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                  <Dropdown
                    placeholder="Select Column"
                    options={getCols(selections[`${elKey}-mod`], selections[`${elKey}-sec`], selections[`${elKey}-sub`])}
                    value={col}
                    onChange={(v) => setSelection(`${elKey}-col`, v)}
                  />
                  <Dropdown
                    placeholder="Select Row"
                    options={getRows(selections[`${elKey}-mod`], selections[`${elKey}-sec`], selections[`${elKey}-sub`])}
                    value={row}
                    onChange={(v) => setSelection(`${elKey}-row`, v)}
                  />
                </div>
              ) : (
                <>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "4px" }}>
                    <Dropdown
                      placeholder="Select Column"
                      options={getCols(selections[`${elKey}-mod`], selections[`${elKey}-sec`], selections[`${elKey}-sub`])}
                      value={col}
                      onChange={(v) => setSelection(`${elKey}-col`, v)}
                    />
                    <Dropdown
                      placeholder="Select Row"
                      options={getRows(selections[`${elKey}-mod`], selections[`${elKey}-sec`], selections[`${elKey}-sub`])}
                      value={row}
                      onChange={(v) => setSelection(`${elKey}-row`, v)}
                    />
                  </div>
                  {col && row && (
                    <div className={styles.selected} style={{ fontSize: "13px", marginTop: "6px" }}>
                      Selected <strong>{row}</strong> in <strong>{col}</strong>
                    </div>
                  )}
                </>
              )}
            </div>
          )}
        </div>
      </div>

      {hasModifiers && (
        <div className={styles.modifierContainer}>
          {(showAllMods ? mods : []).map((mod) => (
            <div key={mod.id} className={styles.modifierCard}>
              <div className={styles.modifierTop}>
                <OperatorBtn
                  value={mod.operator || "＋"}
                  onChange={(op) => updateModifierOperator(elKey, mod.id, op)}
                  isModifier={true}
                />
                <div className={styles.modifierDelete} onClick={() => removeModifier(elKey, mod.id)}>
                  <DeleteGreyIcon className={styles.deleteDefault} />
                  <DeleteIcon className={styles.deleteHover} />
                </div>
              </div>

              {mod.type === "chooser" && (
                <div className={styles.modifierActions}>
                  <button className={styles.modifierBtn} onClick={() => updateModifierType(elKey, mod.id, "single")}>
                    Single Value
                  </button>
                  <button className={styles.modifierBtn} onClick={() => updateModifierType(elKey, mod.id, "linked")}>
                    Link to Cell
                  </button>
                </div>
              )}

              {mod.type === "single" && (
                <input
                  className={styles.modifierInputFull}
                  placeholder="0.00"
                  value={mod.value || ""}
                  onChange={(e) => updateModifierValue(elKey, mod.id, e.target.value)}
                />
              )}

              {mod.type === "linked" && (
                <div className={styles.modifierLinked}>
                  <LinkedCellBlock
                    elKey={`mod-${mod.id}`}
                    isFormula={true}
                    openSections={openSections}
                    setOpenSections={setOpenSections}
                    modifiers={{}}
                    selections={selections}
                    setSelection={setSelection}
                    moduleOpts={moduleOpts}
                    getSections={getSections}
                    getSubSections={getSubSections}
                    getCols={getCols}
                    getRows={getRows}
                    showLabels={false}
                    isPrefilled={isPrefilled}
                  />
                </div>
              )}
            </div>
          ))}

          {!showAllMods && mods.length > 0 && (
            <div className={styles.viewMore} onClick={() => setShowAllMods(true)}>
              View {mods.length} more
            </div>
          )}
        </div>
      )}
    </div>
  );
};


// ── Formula preview bar ───────────────────────────────────────────────────
const FormulaPreview = ({ baseLabel, terms }) => {
  if (!terms || terms.length === 0) return null;

  const DISPLAY_OP = { "+": "＋", "-": "－", "*": "×", "/": "÷" };

  const parts = terms.map((t, i) => {
    const opDisplay = i === 0 ? "" : ` ${DISPLAY_OP[t.operator] || t.operator} `;
    if (t.type === "constant") return `${opDisplay}${t.value ?? t.constant ?? 0}`;
    if (t.type === "cell") return `${opDisplay}${t.row || t.subSection || t.section || "Cell"}`;
    return opDisplay;
  });

  return (
    <div
      style={{
        background: "#f7f9f8",
        border: "1px solid #d4e8dc",
        borderRadius: "8px",
        padding: "10px 14px",
        marginTop: "14px",
        fontSize: "13px",
        color: "#1a202c",
        lineHeight: "1.6",
      }}
    >
      <div style={{ color: "#999", fontSize: "11px", marginBottom: "4px" }}>Formula</div>
      <div>
        <span style={{ color: "#205A46", fontWeight: 600 }}>
          {baseLabel || "Cell Value"}
        </span>{" "}
        = {parts.join("")}
      </div>
    </div>
  );
};

const SidePanel = ({ showLinkPanel, setShowLinkPanel, onApply, tempId, selectedCell, activeCellKey, disclosureID, type, cashflowWorkingsID, cashflowID, dataID, groupingTemplateID, isTemplate, table, onSaveSuccess  }) => {
  const [linkType,     setLinkType]     = useState("single");
  const [openSections, setOpenSections] = useState({});
  const [selections,   setSelections]   = useState({});
  const [modifiers,    setModifiers]    = useState({});
  const [elements,     setElements]     = useState([]);
  const [operators,    setOperators]    = useState({});
  const [apiOptions,   setApiOptions]   = useState({});
  const finalTemplateID = groupingTemplateID || tempId;
  const MODULE_OPTS = Object.keys(apiOptions);
  const [cellSelections, setCellSelections] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [cellModifiers, setCellModifiers] = useState({});
  const [cellElements, setCellElements] = useState({});
  const [cellOperators, setCellOperators] = useState({});
  const [isBold, setIsBold] = useState(false);
  const [isTotal, setIsTotal] = useState(false);
  const [isSubtotal, setIsSubtotal] = useState(false);

  const handleTotalToggle = (val) => {
    setIsTotal(val);
    if (val) {
      setIsBold(true);
      setIsSubtotal(false);
    }
  };

  const handleSubtotalToggle = (val) => {
    setIsSubtotal(val);
    if (val) {
      setIsBold(true);
      setIsTotal(false);
    }
  };
  const panelRef = useRef(null);
  const closeTimeoutRef = useRef(null);
  const COL_MAP = {
    cy: "currentYear",
    py: "previousYear",
    amountCY: "currentYear",
    amountPY: "previousYear",
  };
  const formatColName = (col) => {
    if (!col) return "";
    const lower = col.toLowerCase();
    if (lower === "currentyear" || lower === "cy" || lower === "amountcy") {
      return "current year";
    }
    if (lower === "previousyear" || lower === "py" || lower === "amountpy") {
      return "previous year";
    }
    return col;
  };
  const standaloneCategory =
    type === "cashflow"
      ? "cashflow"
      : type === "cashflowworkings"
      ? "cashflowworkings"
      : cashflowWorkingsID
      ? "cashflowworkings"
      : type === "socie"
      ? "socie"
      : "disclosure";
const [isPrefilled, setIsPrefilled] = useState(false);
  const panelWidth = React.useMemo(() => {
    if (linkType !== "formula") return 550;
    const hasBase = selections["base-mod"];
    if (elements.length === 0 && !hasBase) return 550;
    if (isTemplate) {
      return Math.min(1080, window.innerWidth * 0.52);
    }
    return Math.min(960, window.innerWidth * 0.95);
  }, [linkType, elements.length, selections, isTemplate]);

  useEffect(() => {
  if (!showLinkPanel) return;
  if (!finalTemplateID) return;

  // TEMPLATE FLOW
  if (isTemplate) {

   const apiCall = getFormulaOptions;

    apiCall(finalTemplateID)
      .then((res) => {
        if (res?.data?.success) {
          setApiOptions(res.data.options || {});
        }
      })
      .catch(console.error);

  }

  // STANDALONE 
  else {

    getPopulateFSFormulaOptions(finalTemplateID)
      .then((res) => {
        if (res?.data?.success) {
          setApiOptions(res.data.options || {});
        }
      })
      .catch(console.error);

  }

}, [showLinkPanel, finalTemplateID, type, isTemplate]);

  // Clear any scheduled close timeout when activeCellKey changes (new cell selected)
  useEffect(() => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }
  }, [activeCellKey]);


// useEffect(() => {
//   if (!activeCellKey) return;
//   setSelections({});
//   setElements([]);
//   setOperators({});
//   setModifiers({});
//   setOpenSections({});
//   setLinkType("single");
//   setIsPrefilled(false);
// }, [activeCellKey]);

useEffect(() => {
  if (!activeCellKey) return;

  // if (cellSelections[activeCellKey]) return;

  setSelections({});
  setElements([]);
  setOperators({});
  setModifiers({});
  setOpenSections({});
  setLinkType("single");
  setIsPrefilled(false);
  setIsBold(false);
  setIsTotal(false);
  setIsSubtotal(false);
}, [activeCellKey]);

useEffect(() => {
  const fetchFormulaData = async () => {
    if (!activeCellKey || !selectedCell) return;

    try {
      let groupingTemplate = null;
      try {
        const res = isTemplate
          ? await getTemplateDetailsApiHandler({
              groupingTemplateID: finalTemplateID,
            })
          : await getPopulateFSDetailsApiHandler({
              projectID: finalTemplateID,
              category: standaloneCategory,
            });

        groupingTemplate = isTemplate
          ? res?.data?.groupingTemplate
          : {
              [standaloneCategory === "disclosure" ? "disclosures" : standaloneCategory]:
                res?.data?.data,
            };
      } catch (err) {
        console.warn("Could not fetch grouping template details, proceeding with table data.", err);
      }
     const normalizedCellKey = `${cashflowWorkingsID || ''}-${dataID || ''}-${selectedCell?.row || ''}-${selectedCell?.col || ''}`;
      const normalize = (v) => String(v || "").trim().toLowerCase();

      // collect formulas from the specific table only
      let freshTableFormulas = [];

     const findInTree = (items = []) => {
  for (const item of items) {
    // Direct match (for grouping/subgroup items)
    if (String(item._id) === String(dataID)) {
      if (item.cellFormulas?.length) {
        freshTableFormulas = item.cellFormulas;
      }
      return true;
    }
    if (Array.isArray(item.data)) {
      for (const block of item.data) {
        if (String(block._id) === String(dataID)) {
          if (block.cellFormulas?.length) {
            freshTableFormulas = block.cellFormulas;
          }
          return true;
        }
      }
    }
    if (item.subgroup && findInTree(item.subgroup)) return true;
    if (item.subNotes && findInTree(item.subNotes)) return true;
    if (item.data && findInTree(item.data)) return true;
  }
  return false;
};

      if (groupingTemplate?.grouping) findInTree(groupingTemplate.grouping);
      if (!freshTableFormulas.length && groupingTemplate?.cashflowWorkings) {
        findInTree(groupingTemplate.cashflowWorkings);
      }
      if (!freshTableFormulas.length && groupingTemplate?.cashflowworkings) {
        findInTree(groupingTemplate.cashflowworkings);
      }
      if (!freshTableFormulas.length && groupingTemplate?.cashflow) {
        findInTree(groupingTemplate.cashflow);
      }
      if (!freshTableFormulas.length && groupingTemplate?.disclosures) {
        findInTree(groupingTemplate.disclosures);
      }
      if (!freshTableFormulas.length && groupingTemplate?.disclosure) {
        findInTree(groupingTemplate.disclosure);
      }
      if (!freshTableFormulas.length && groupingTemplate?.socie) {
        findInTree(groupingTemplate.socie);
      }

      if (!freshTableFormulas.length && table?.cellFormulas?.length) {
        freshTableFormulas = table.cellFormulas;
      }

      const selectedCol =
        COL_MAP[selectedCell.col] || selectedCell.col;
      const selectedRow = normalize(selectedCell.row);
      const selectedRowId = normalize(selectedCell.rowId);

      const formula = freshTableFormulas.find((f) => {
        const formulaRow = normalize(f.row || f.rowID || f.rowId);
        const formulaCol = normalize(f.col);
        return (
          formulaCol === normalize(selectedCol) &&
          (formulaRow === selectedRow || (selectedRowId && formulaRow === selectedRowId))
        );
      });
      console.log("activeCellKey", activeCellKey);
      console.log("selectedCell", selectedCell);
      console.log("freshTableFormulas", freshTableFormulas);
      console.log("matchedFormula", formula);
      

      if (!formula) {
        setSelections({});
        setElements([]);
        setOperators({});
        setModifiers({});
        setLinkType("single");
        setIsPrefilled(false);
        setIsBold(false);
        setIsTotal(false);
        setIsSubtotal(false);
        return;
      }

      // SINGLE LINK
      if (formula.type === "link" || (!formula.terms && formula.link)) {
        setLinkType("single");
        setIsPrefilled(true);

        const saved = {
          "s-mod": formula.link?.module || "",
          "s-sec": formula.link?.section || "",
          "s-sub": formula.link?.subSection || "",
          "s-row": formula.link?.row || "",
          "s-col": formula.link?.col || "",
        };

        setSelections(saved);

        setElements([]);
        setOperators({});
        setModifiers({});
        setIsBold(formula.isBold || false);
        setIsTotal(formula.formulaType === "total");
        setIsSubtotal(formula.formulaType === "subtotal");
      }

      // FORMULA
      if (formula.type === "formula" || formula.terms) {
        setLinkType("formula");
        setIsPrefilled(true);
        setIsBold(formula.isBold || false);
        setIsTotal(formula.formulaType === "total");
        setIsSubtotal(formula.formulaType === "subtotal");

        const terms = formula.terms || [];

        if (terms.length > 0) {
          const first = terms[0];
          const isBaseCell = first.type === "cell" || !!first.module;

          const reverseMap = {
            "+": "＋",
            "-": "－",
            "*": "×",
            "/": "÷",
          };

          const ops = {};
          const els = [];
          const sel = {};

          if (isBaseCell) {
            setSelections({
              "base-mod": first.module || "",
              "base-sec": first.section || "",
              "base-sub": first.subSection || "",
              "base-row": first.row || "",
              "base-col": first.col || "",
            });
            ops["base"] = reverseMap[first.operator] || "＋";

            terms.slice(1).forEach((t, idx) => {
              const id = Date.now() + idx;
              ops[`op-${idx}`] = reverseMap[t.operator] || "＋";

              const isConstant = t.type === "constant" || t.value !== undefined || t.constant !== undefined;
              const isCell = t.type === "cell" || !!t.module;

              if (isConstant) {
                els.push({ id, type: "value", value: String(t.value ?? t.constant ?? "") });
              } else if (isCell) {
                els.push({ id, type: "linked" });
                sel[`el-${id}-mod`] = t.module || "";
                sel[`el-${id}-sec`] = t.section || "";
                sel[`el-${id}-sub`] = t.subSection || "";
                sel[`el-${id}-row`] = t.row || "";
                sel[`el-${id}-col`] = t.col || "";
              }
            });
          } else {
            // First term is a constant, move everything to elements
            terms.forEach((t, idx) => {
              const id = Date.now() + idx;
              ops[`op-${idx}`] = reverseMap[t.operator] || "＋";

              const isConstant = t.type === "constant" || t.value !== undefined || t.constant !== undefined;
              const isCell = t.type === "cell" || !!t.module;

              if (isConstant) {
                els.push({ id, type: "value", value: String(t.value ?? t.constant ?? "") });
              } else if (isCell) {
                els.push({ id, type: "linked" });
                sel[`el-${id}-mod`] = t.module || "";
                sel[`el-${id}-sec`] = t.section || "";
                sel[`el-${id}-sub`] = t.subSection || "";
                sel[`el-${id}-row`] = t.row || "";
                sel[`el-${id}-col`] = t.col || "";
              }
            });
          }

          setOperators(ops);
          setElements(els);
          setSelections((prev) => ({ ...prev, ...sel }));
          setModifiers({});
          setIsPrefilled(true);
        }
      }
    } catch (err) {
      console.error("Prefill API Error", err);
    }
  };

  fetchFormulaData();
}, [activeCellKey, selectedCell, apiOptions, showLinkPanel]);

useEffect(() => {
  if (!activeCellKey) return;

  const savedSel = cellSelections[activeCellKey];
  if (savedSel && Object.keys(savedSel).length > 0) {
    setSelections(savedSel);
    setModifiers(cellModifiers[activeCellKey] || {});
    setElements(cellElements[activeCellKey] || []);
    setOperators(cellOperators[activeCellKey] || {});
  }
}, [activeCellKey]);

const proceedWithDeleteLink = async () => {
  setCellSelections((prev) => {
    const updated = { ...prev };
    delete updated[activeCellKey];
    return updated;
  });

  setCellModifiers((prev) => {
    const updated = { ...prev };
    delete updated[activeCellKey];
    return updated;
  });

  setCellElements((prev) => {
    const updated = { ...prev };
    delete updated[activeCellKey];
    return updated;
  });

  setCellOperators((prev) => {
    const updated = { ...prev };
    delete updated[activeCellKey];
    return updated;
  });

  if (!selectedCell?.row || !selectedCell?.col) return;

  try {
    setIsDeleting(true);

    const finalCol = COL_MAP[selectedCell.col] || selectedCell.col;
    const isWorkings = type === "cashflow" && cashflowWorkingsID;
    const isSocie = type === "socie";
    let deleteApi;

    if (isTemplate) {
      deleteApi = isSocie
        ? deleteSocieCellFormula
        : (
            isWorkings
              ? deleteCashflowCellFormula
              : (
                  type === "cashflow"
                    ? deleteCashflow
                    : deleteDisclosureCellFormula
                )
          );
    } else {
      if (type === "socie") {
        deleteApi = deleteStandaloneSocieCellFormula;
      } else if (type === "cashflow" && cashflowWorkingsID) {
        deleteApi = deleteStandaloneCashflowWorkingsCellFormula;
      } else if (type === "cashflow") {
        deleteApi = deleteStandaloneCashflowCellFormula;
      } else {
        deleteApi = deleteStandaloneDisclosureCellFormula;
      }
    }
      
    let params;

    if (isTemplate) {
      params = isSocie
        ? {
            groupingTemplateID: finalTemplateID,
            socieID: disclosureID,
            dataID,
            row: selectedCell.row,
            col: finalCol,
          }
        : (
            isWorkings
              ? {
                  groupingTemplateID: finalTemplateID,
                  cashflowWorkingsID: cashflowWorkingsID || null,
                  dataID,
                  row: selectedCell.row,
                  col: finalCol,
                }
              : (
                  type === "cashflow"
                    ? {
                        groupingTemplateID: finalTemplateID,
                        dataID,
                        row: selectedCell.row,
                        col: finalCol,
                      }
                    : {
                        groupingTemplateID: finalTemplateID,
                        disclosureID,
                        dataID,
                        row: selectedCell.row,
                        col: finalCol,
                      }
                )
          );
    } else {
      if (type === "socie") {
        params = {
          projectID: finalTemplateID,
          row: selectedCell.row,
          col: finalCol,
        };
      } else if (type === "cashflow" && cashflowWorkingsID) {
        params = {
          projectID: finalTemplateID,
          cashflowWorkingsID,
          subgroupID: dataID,
          row: selectedCell.row,
          col: finalCol,
        };
      } else if (type === "cashflow") {
        params = {
          projectID: finalTemplateID,
          row: selectedCell.row,
          col: finalCol,
        };
      } else {
        params = {
          projectID: finalTemplateID,
          disclosureID,
          subgroupID: dataID,
          row: selectedCell.row,
          col: finalCol,
        };
      }
    }

    await deleteApi(params);

    setSelections({});
    setElements([]);
    setOperators({});
    setModifiers({});
    setOpenSections({});
    setLinkType("single");
    setIsPrefilled(false);

    onApply && onApply(null);
    setShowLinkPanel(false);             
    
    setTimeout(() => {
      onSaveSuccess && onSaveSuccess();
    }, 0);

    Swal({
      title: "Deleted Successfully!",
      icon: "success",
      buttons: false,
      timer: 1500,
      className: "custom-swal",
    });
  } catch (err) {
    console.error("DELETE ERROR", err?.response || err);
    const backendError =
      err?.response?.data?.message ||
      err?.response?.data?.error ||
      "Delete failed";

    Swal({
      title: "Error",
      text: backendError,
      icon: "error",
    });
  } finally {
    setIsDeleting(false);
  }
};

const handleDeleteLink = async () => {
  if (isTemplate) {
    setDeleteConfirm({
      title: "Are you sure?",
      message: "This link will be deleted permanently",
      onConfirm: async () => {
        setDeleteConfirm(null);
        await proceedWithDeleteLink();
      }
    });
  } else {
    const confirm = await Swal({
      title: "Are you sure?",
      text: "This link will be deleted permanently",
      icon: "warning",
      buttons: ["Cancel", "Delete"],
      dangerMode: true,
    });
    if (confirm) {
      await proceedWithDeleteLink();
    }
  }
};


  const getSections = (module) => {
    if (!module || !apiOptions[module]) return [];
    return apiOptions[module].map((item) => item.section);
  };

  const getSubSections = (module, section) => {
    if (!module || !section || !apiOptions[module]) return [];
    const found = apiOptions[module].find((item) => item.section === section);
    return found && found.subSections ? found.subSections.map((s) => s.subSection) : [];
  };

  const getSubSectionMeta = (module, section, subSection) => {
    if (!module || !section || !subSection || !apiOptions[module]) return null;
    const sec = apiOptions[module].find((item) => item.section === section);
    if (!sec || !sec.subSections) return null;
    return sec.subSections.find((s) => s.subSection === subSection) || null;
  };

  const getCols = (module, section, subSection) => {
    const meta = getSubSectionMeta(module, section, subSection);
    return meta?.cols || [];
  };

  const getRows = (module, section, subSection) => {
    const meta = getSubSectionMeta(module, section, subSection);
    return meta?.rows || [];
  };

  if (!showLinkPanel) return null;

  const setSelection = (k, v) => {
  setSelections((prev) => {
    const updated = { ...prev, [k]: v };

    setCellSelections((all) => ({
      ...all,
      [activeCellKey]: updated,
    }));

    return updated;
  });
};

  const addModifier = (k) => {
    setModifiers((prev) => {
      const updated = {
        ...prev,
       [k]: [
        ...(prev[k] || []),
        {
          id: Date.now(),
          operator: "＋",
          type: "chooser",
          value: "",
        },
      ],
      };

      setCellModifiers((all) => ({
        ...all,
        [activeCellKey]: updated,
      }));

      return updated;
    });
  };
 const updateModifierValue = (k, id, v) => {
  setModifiers((prev) => {
    const updated = {
      ...prev,
      [k]: prev[k].map((m) => (m.id === id ? { ...m, value: v } : m)),
    };

    setCellModifiers((all) => ({
      ...all,
      [activeCellKey]: updated,
    }));

    return updated;
  });
};

const updateModifierType = (k, id, type) => {
  setModifiers((prev) => {
    const updated = {
      ...prev,
      [k]: prev[k].map((m) =>
        m.id === id ? { ...m, type } : m
      ),
    };

    setCellModifiers((all) => ({
      ...all,
      [activeCellKey]: updated,
    }));

    return updated;
  });

  if (type === "linked") {
    setOpenSections((prev) => ({
      ...prev,
      [`mod-${id}-module`]: `mod-${id}-module`,
    }));
  }
};


  const removeModifier = (k, id) =>
    setModifiers((p) => ({ ...p, [k]: p[k].filter((m) => m.id !== id) }));
 
  const addElement = () => {
  setElements((prev) => {
    const updated = [...prev, { id: Date.now(), type: "chooser", value: "" }];

    setCellElements((all) => ({
      ...all,
      [activeCellKey]: updated,
    }));

    return updated;
  });
};

const removeElement = (id) => {
  setElements((prev) => {
    const updated = prev.filter((el) => el.id !== id);

    setCellElements((all) => ({
      ...all,
      [activeCellKey]: updated,
    }));

    return updated;
  });

  setSelections((prev) => {
    const updated = { ...prev };
    Object.keys(updated).forEach((key) => {
      if (key.startsWith(`el-${id}`)) {
        delete updated[key];
      }
    });

    setCellSelections((all) => ({
      ...all,
      [activeCellKey]: updated,
    }));

    return updated;
  });
};

const updateModifierOperator = (k, id, op) => {
  setModifiers((prev) => {
    const updated = {
      ...prev,
      [k]: prev[k].map((m) =>
        m.id === id ? { ...m, operator: op } : m
      ),
    };

    setCellModifiers((all) => ({
      ...all,
      [activeCellKey]: updated,
    }));

    return updated;
  });
};

const setElType = (id, t) => {
  setElements((prev) => {
    const updated = prev.map((el) =>
      el.id === id ? { ...el, type: t, value: "" } : el
    );

    setCellElements((all) => ({
      ...all,
      [activeCellKey]: updated,
    }));

    return updated;
  });

  if (t === "linked") {
    setOpenSections((prev) => ({
      ...prev,
      [`el-${id}-module`]: `el-${id}-module`,
    }));
  }
};

const setElValue = (id, v) => {
  setElements((prev) => {
    const updated = prev.map((el) =>
      el.id === id ? { ...el, value: v } : el
    );

    setCellElements((all) => ({
      ...all,
      [activeCellKey]: updated,
    }));

    return updated;
  });
};

  const setOperator = (k, v) => {
  setOperators((prev) => {
    const updated = { ...prev, [k]: v };

    setCellOperators((all) => ({
      ...all,
      [activeCellKey]: updated,
    }));

    return updated;
  });
};
  const buildFormulaTerms = () => {
    const terms = [];

    const baseMod = selections["base-mod"];
    const baseSec = selections["base-sec"];
    const baseSub = selections["base-sub"];
    const baseRow = selections["base-row"];
    const baseCol = selections["base-col"];

    if (baseMod && baseRow && baseCol) {
    const baseTerm = {
      type: isTemplate ? "cell" : "ref",
    };

      if (baseMod) baseTerm.module = baseMod;
      if (baseSec) baseTerm.section = baseSec;
      if (baseSub) baseTerm.subSection = baseSub;
      if (baseRow) baseTerm.row = baseRow;
      if (baseCol) baseTerm.col = COL_MAP[baseCol] || baseCol;

      terms.push(baseTerm);
    }

    // (modifiers["base"] || []).forEach((mod) => {
    //   terms.push({
    //     operator: OPERATOR_MAP[mod.operator || "＋"],
    //     type: "constant",
    //     value: parseFloat(mod.value) || 0,
    //   });
    // });

    elements.forEach((el, idx) => {
  const op = OPERATOR_MAP[operators[`op-${idx}`] || "＋"];
  const hasBase = !!(selections["base-mod"] && selections["base-row"] && selections["base-col"]);
  const isFirstTerm = !hasBase && idx === 0;

  if (el.type === "value") {
    terms.push({
      ...(isFirstTerm ? {} : { operator: op }),
      type: isTemplate ? "constant" : "value",
      [isTemplate ? "constant" : "value"]:
      el.value !== "" && !isNaN(Number(el.value))
        ? Number(el.value)
        : null, 
    });
  }

  if (el.type === "linked") {
    const k = `el-${el.id}`;
    const elTerm = {
      ...(isFirstTerm ? {} : { operator: op }),
      type: isTemplate ? "cell" : "ref",
    };
    const mod = selections[`${k}-mod`];
    const sec = selections[`${k}-sec`];
    const sub = selections[`${k}-sub`];
    const row = selections[`${k}-row`];
    const col = selections[`${k}-col`];

    if (mod) elTerm.module = mod;
    if (sec) elTerm.section = sec;
    if (sub) elTerm.subSection = sub;
    if (row) elTerm.row = row;
    if (col) elTerm.col = COL_MAP[col] || col;

    terms.push(elTerm);
  }
});

    return terms;
  };

  const handleClose = () => setShowLinkPanel(false);



  const handleApply = async () => {
    
    console.log("COMPARE");
    console.log("dataID", dataID);
    console.log("table._id", table?._id);
    console.log("cashflowID", cashflowID);
    if (!selectedCell?.row || !selectedCell?.col) {
        console.error("Invalid selectedCell", selectedCell);
        return;
      }
    const isValidObjectId = (id) => /^[0-9a-fA-F]{24}$/.test(id);

   if (isTemplate && type === "cashflow") {

  if (!dataID) {
    console.error("Missing cashflow dataID");
    return;
  }

  // if (!isValidObjectId(dataID)) {
  //   Swal(
  //     "Action Required",
  //     "Please save the template first to assign a permanent ID to this table before linking cells.",
  //     "info"
  //   );
  //   return;
  // }

  if (
    cashflowWorkingsID &&
    !isValidObjectId(cashflowWorkingsID)
  ) {
    console.warn(
      "Invalid cashflowWorkingsID format",
      cashflowWorkingsID
    );
  }

  if (
    cashflowID &&
    !isValidObjectId(cashflowID)
  ) {
    console.warn(
      "Invalid cashflowID format",
      cashflowID
    );
  }

}

    console.log("Elements ", elements);
    console.log("Operators", operators);
    console.log("Param Check ", { tempId, disclosureID, dataID, selectedCell });

    let body = null;

  const finalCol = COL_MAP[selectedCell.col] || selectedCell.col;

  if (linkType === "single") {

  const link = {
    module: selections["s-mod"] || "",
    section: selections["s-sec"] || "",
    subSection: selections["s-sub"] || "",
    row: selections["s-row"] || "",
    col:
      COL_MAP[selections["s-col"]] ||
      selections["s-col"] ||
      "",
  };

  body = {
    row: selectedCell.row,
    col: finalCol,
    type: "link",
    link,
    isBold: isBold || isTotal || isSubtotal,
    formulaType: isTotal ? "total" : isSubtotal ? "subtotal" : null,
  };
} else {
      const terms = buildFormulaTerms();

      if (terms.length === 0) {
        console.warn("No valid terms, saving empty formula");
      }

    body = {
      row: selectedCell.row,
      col: finalCol,   
      type: "formula",
      terms,
      isBold: isBold || isTotal || isSubtotal,
      formulaType: isTotal ? "total" : isSubtotal ? "subtotal" : null,
    };
    }

    console.log("PUT REQUEST");
    console.log("PARAMS ", { groupingTemplateID: finalTemplateID, disclosureID, dataID });
    console.log("PUT Body", body);
    console.log("[SidePanel Apply Debug]", {
      type,
      isTemplate,
      selectedCell,
      activeCellKey,
      cashflowWorkingsID,
      cashflowID,
      disclosureID,
      dataID,
      tableIdFromProp: table?._id,
      tableTitleFromProp: table?.tableTitle,
      availableTableRows: table?.tableRow?.map((row) => row?.name),
      availableCellFormulaRows: table?.cellFormulas?.map((formula) => ({
        row: formula?.row,
        col: formula?.col,
        type: formula?.type,
      })),
    });

    try {
      setIsSaving(true);

      const isWorkings = type === "cashflow" && cashflowWorkingsID;
      const isSocie = type === "socie";
      let saveApi;

if (isTemplate) {

  // EXISTING TEMPLATE FLOW
  saveApi = isSocie
    ? setSocieCellFormula
    : (
        isWorkings
          ? setCashflowCellFormula
          : (
              type === "cashflow"
                ? setCashflow
                : setDisclosureCellFormula
            )
      );

} else {

  // STANDALONE FLOW
  if (type === "socie") {

    saveApi = setStandaloneSocieCellFormula;

  } else if (
    type === "cashflow" &&
    cashflowWorkingsID
  ) {

    saveApi =
      setStandaloneCashflowWorkingsCellFormula;

  } else if (type === "cashflow") {

    saveApi = setStandaloneCashflowCellFormula;

  } else {
    saveApi =
      setStandaloneDisclosureCellFormula;

  }

}

let params;

if (isTemplate) {

  // EXISTING TEMPLATE PARAMS
  params = isSocie
    ? {
        groupingTemplateID: finalTemplateID,
        socieID: disclosureID,
        dataID,
      }
    : (
        isWorkings
          ? {
              groupingTemplateID: finalTemplateID,
              cashflowWorkingsID,
              dataID,
            }
          : (
              type === "cashflow"
                ? {
                    groupingTemplateID: finalTemplateID,
                    // cashflowID,
                    dataID,
                  }
                : {
                    groupingTemplateID: finalTemplateID,
                    disclosureID,
                    dataID,
                  }
            )
      );

} else {

  // STANDALONE PARAMS
  if (type === "socie") {

    params = {
      projectID: finalTemplateID,
    };

  } else if (
    type === "cashflow" &&
    cashflowWorkingsID
  ) {

    params = {
      projectID: finalTemplateID,
      cashflowWorkingsID,
      subgroupID: dataID,
    };

  } else if (type === "cashflow") {

    params = {
      projectID: finalTemplateID,
    };

  } else {

    params = {
      projectID: finalTemplateID,
      disclosureID,
      subgroupID: dataID,
    };
    console.log("DISCLOSURE PARAMS", params);
    

  }

}
      const res = await saveApi(params, body);
      if (res?.data?.success) {
        if (linkType === "single") {
          const saved = {
            "s-mod": selections["s-mod"],
            "s-sec": selections["s-sec"],
            "s-sub": selections["s-sub"],
            "s-row": selections["s-row"],
            "s-col": selections["s-col"],
          };

          setSelections((prev) => ({
            ...prev,
            ...saved,
          }));

          setCellSelections((all) => ({
            ...all,
            [activeCellKey]: saved,
          }));
        }
        const freshData = res.data?.updatedGroupingTemplate || res.data?.updatedProject || res.data?.data;
        onApply && onApply(body, freshData);
        onSaveSuccess && onSaveSuccess(freshData);
        setShowLinkPanel(false);
        Swal({
          title: "Linked Successfully!",
          icon: "success",
          buttons: false,
          timer: 1500,
          className: "custom-swal",
        });
      } else {
        Swal({
          title: "Error",
          text: res?.data?.message || "Something went wrong. Please try again.",
          icon: "error",
          button: "OK",
        });
      }
      } catch (err) {

  console.error(
    "PUT API ERROR",
    err?.response || err
  );

  const backendError =
    err?.response?.data?.message ||
    err?.response?.data?.error ||
    err?.response?.data?.errors?.[0]?.message ||
    "Something went wrong. Please try again.";

  Swal({
    title: "Error",
    text: backendError,
    icon: "error",
    button: "OK",
  });

}finally {
      setIsSaving(false);
    }
  };

  const compileFormulaPreview = () => {
    const parts = [];
    const baseRow = selections["base-row"];
    const baseMod = selections["base-mod"];
    const baseCol = selections["base-col"];
    const hasBase = !!(baseMod && baseRow && baseCol);

    if (hasBase) {
      const baseDisplay =
        baseRow?.toLowerCase() === "total"
          ? `${selections["base-sub"]} (Total)`
          : baseRow;

      parts.push(<React.Fragment key="base">{baseDisplay}</React.Fragment>);
    }

    elements.forEach((el, idx) => {
      const rawOp = operators[`op-${idx}`] || "＋";
      const displayOp = OPERATOR_MAP[rawOp] || rawOp;
      const renderOp = (hasBase || idx > 0) ? (
        <span style={{ fontWeight: "bold", color: "#000", display: "inline-flex", alignItems: "center", gap: "2px", verticalAlign: "middle" }}>
          <span>(</span>
          <span style={{ display: "flex", alignItems: "center", transform: "translateY(-1.5px)" }}><OperatorIcon type={displayOp} size={16} /></span>
          <span>)</span>
        </span>
      ) : "";

      if (el.type === "value") {
        parts.push(<React.Fragment key={`val-${idx}`}> {renderOp} {el.value || "0"}</React.Fragment>);
      } else if (el.type === "linked") {
        const linkedRow = selections[`el-${el.id}-row`] || "(?)";
        const linkedSub =
          selections[`el-${el.id}-sub`] || "";

        const linkedDisplay =
          linkedRow?.toLowerCase() === "total"
            ? `${linkedSub} (Total)`
            : linkedRow;

        parts.push(<React.Fragment key={`link-${idx}`}> {renderOp} {linkedDisplay}</React.Fragment>);
      } else {
        parts.push(<React.Fragment key={`q-${idx}`}> {renderOp} (?)</React.Fragment>);
      }
    });

    if (parts.length === 0) {
      return "(?)";
    }
    return parts;
  };

  // renderSingle: labels shown, col+row side by side, selected text shown ──
  const renderSingle = () => {
    const mod = selections["s-mod"];
    const sec = selections["s-sec"];
    const sub = selections["s-sub"];

    return (
      <>
        <Dropdown
          label="Select Module"
          placeholder="Select module"
          options={MODULE_OPTS}
          value={mod}
          onChange={(v) => {
            setSelection("s-mod", v);
            setSelection("s-sec", "");
            setSelection("s-sub", "");
            setSelection("s-col", "");
            setSelection("s-row", "");
          }}
        />
        <Dropdown
          label="Select Section"
          placeholder="Select section"
          options={getSections(mod)}
          value={sec}
          onChange={(v) => {
            setSelection("s-sec", v);
            setSelection("s-sub", "");
            setSelection("s-col", "");
            setSelection("s-row", "");
          }}
        />
        <Dropdown
          label="Select Sub-Section"
          placeholder="Select sub-section"
          options={getSubSections(mod, sec)}
          value={sub}
          onChange={(v) => {
            setSelection("s-sub", v);
            setSelection("s-col", "");
            setSelection("s-row", "");
          }}
        />
        <div className={styles.field}>
          <label>Select Cell</label>
          <div style={{ display: "grid", gridTemplateColumns: "auto 1fr", gap: "14px" }}>
            <Dropdown
              placeholder="Select Column"
              options={getCols(mod, sec, sub)}
              value={selections["s-col"]}
              onChange={(v) => setSelection("s-col", v)}
            />
            <Dropdown
              placeholder="Select Row"
              options={getRows(mod, sec, sub)}
              value={selections["s-row"]}
              onChange={(v) => setSelection("s-row", v)}
            />
          </div>
        </div>
        {selections["s-col"] && selections["s-row"] && (
         <div
            className={styles.selected}
            style={{ whiteSpace: "normal", overflow: "visible", textOverflow: "unset" }}
          >
          Selected <strong>{selections["s-row"]}</strong> in{" "}
          <strong>{selections["s-col"]}</strong>
        </div>
        )}
      </>
    );
  };

  // ── renderFormula: no labels, col+row on separate lines, no selected text ──
  const renderFormula = () => {
    return (
      <div className={styles.formulaContainer}>
        {/* Base Block */}
        {(selections["base-mod"]) && (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div className={styles.leftWrapper}>
              <div className={`${styles.formulaLeft} ${isPrefilled ? styles.prefilledContainer : ""} ${modifiers["base"]?.length > 0 ? styles.whiteBlock : ""}`} style={{ position: "relative" }}>
                {isPrefilled && (
                  <div
                    className={styles.baseDelete}
                    onClick={handleDeleteLink}
                    title="Delete link"
                  >
                    <RemoveIcon width={14} height={14} />
                  </div>
                )}
                <LinkedCellBlock
                  key={`base-${activeCellKey}`}
                  elKey="base"
                  isFormula={true}
                  openSections={openSections}
                  setOpenSections={setOpenSections}
                  modifiers={modifiers}
                  addModifier={addModifier}
                  updateModifierOperator={updateModifierOperator}
                  updateModifierValue={updateModifierValue}
                  selections={selections}
                  setSelection={setSelection}
                  moduleOpts={MODULE_OPTS}
                  getSections={getSections}
                  getSubSections={getSubSections}
                  getCols={getCols}
                  getRows={getRows}
                  showLabels={false}
                  showAddModifier={false}
                  removeModifier={removeModifier}
                  updateModifierType={updateModifierType}
                  isPrefilled={isPrefilled}
                />
              </div>
            </div>
            <div
              className={styles.addModifierBelow}
              onClick={() => addModifier("base")}
            >
              <AddIcon className={styles.addIcon} />
              <span style={{ color: "#2D8861", fontSize: "16px"}}>Add Modifier</span>
            </div>
          </div>
        )}

        {/* First Operator */}
        {(selections["base-mod"]) && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: "120px",
            }}
          >
            <OperatorBtn
              value={operators[`op-0`] || "＋"}
              onChange={(v) => setOperator("op-0", v)}
            />
          </div>
        )}

        {/* Elements */}
        {elements.map((el, idx) => (
          <React.Fragment key={el.id}>
            {idx > 0 && (
               <div
               style={{
                 display: "flex",
                 alignItems: "center",
                 marginTop: "120px",
               }}
             >
              <OperatorBtn
                value={operators[`op-${idx}`] || "＋"}
                onChange={(v) => setOperator(`op-${idx}`, v)}
              />
              </div>
            )}
            
            <div className={styles.elementWrapper} style={{ marginTop: "30px", position: "relative" }}>
              <div
                className={styles.elementDelete}
                onClick={() => removeElement(el.id)}
                title="Remove element"
              >
                <RemoveIcon width={14} height={14} />
              </div>

              {el.type === "chooser" && (
                <div className={styles.choiceBox}>
                  <button onClick={() => setElType(el.id, "value")}>Single Value</button>
                  <span className={styles.orText}>OR</span>
                  <button onClick={() => setElType(el.id, "linked")}>Link to Cell</button>
                </div>
              )}

              {el.type === "value" && (
                <div className={styles.valueBox}>
                  <input
                    type="number"
                    placeholder="0.00"
                    value={el.value}
                    onChange={(e) => setElValue(el.id, e.target.value)}
                  />
                </div>
              )}

              {el.type === "linked" && (
                <div className={styles.linkedWrapper}>
                  <div className={`${styles.formulaLeftSmall} ${isPrefilled ? styles.prefilledContainer : ""} ${modifiers[`el-${el.id}`]?.length > 0 ? styles.whiteBlock : ""}`}>
                    <LinkedCellBlock
                      key={`el-${el.id}-${activeCellKey}`}
                      elKey={`el-${el.id}`}
                      isFormula={true}
                      openSections={openSections}
                      setOpenSections={setOpenSections}
                      modifiers={modifiers}
                      addModifier={addModifier}
                      updateModifierOperator={updateModifierOperator}
                      updateModifierValue={updateModifierValue}
                      selections={selections}
                      setSelection={setSelection}
                      moduleOpts={MODULE_OPTS}
                      getSections={getSections}
                      getSubSections={getSubSections}
                      getCols={getCols}
                      getRows={getRows}
                      showLabels={false}
                      showAddModifier={false}
                      removeModifier={removeModifier}
                      updateModifierType={updateModifierType}
                      isPrefilled={isPrefilled}
                    />
                  </div>
                  <div
                    className={styles.addModifierBelow}
                    onClick={() => addModifier(`el-${el.id}`)}
                  >
                    <AddIcon className={styles.addIcon} />
                    <span style={{ color: "#2D8861", fontSize: "16px"}}>Add Modifier</span>
                  </div>
                </div>
              )}
            </div>
          </React.Fragment>
        ))}

        {/* Add Element Section */}
        {elements.length > 0 && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: "120px",
            }}
          >
            <OperatorBtn
              value={operators[`op-last`] || "＋"}
              onChange={(v) => setOperator("op-last", v)}
            />
          </div>
        )}

        <div style={{ display: "flex", flexDirection: "column" }}>
          <div className={styles.addElementBox} onClick={addElement}>
            <p>+ Add Element</p>
          </div>
          <div className={styles.addModifierBelow} style={{ visibility: "hidden" }}>
            <AddIcon className={styles.addIcon} />
            <span>Add Modifier</span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div ref={panelRef} className={styles.sidePanel} style={{ width: panelWidth }}>
      <div className={styles.panelHeader}  style= {{ fontSize: "18px", display: "flex", justifyContent: "space-between", alignItems: "flex-start", width: "100%", boxSizing: "border-box" }}>
        <Tooltip
          content={`${isPrefilled ? (linkType === "formula" ? "Edit Formula Data" : "Edit Linked Data") : (linkType === "formula" ? "Formula Data" : "Link Data")}${selectedCell?.row && selectedCell?.col ? ` (${selectedCell.row} - ${formatColName(selectedCell.col)})` : ""}`}
          position="bottom"
          variant="black"
          style={{ flex: 1, minWidth: 0 }}
          tooltipStyle={{
            whiteSpace: "normal",
            width: "520px",
            wordBreak: "break-word",
            textAlign: "left",
            lineHeight: "1.6",
            padding: "8px 12px",
            fontSize: "13px",
          }}
        >
          <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "block", paddingRight: "10px", lineHeight: "1.4" }}>
            {isPrefilled ? (linkType === "formula" ? "Edit Formula Data" : "Edit Linked Data") : (linkType === "formula" ? "Formula Data" : "Link Data")}
            {selectedCell?.row && selectedCell?.col ? ` (${selectedCell.row} - ${formatColName(selectedCell.col)})` : ""}
          </span>
        </Tooltip>
        <span className={styles.close} onClick={handleClose} style={{ flexShrink: 0 }}>✕</span>
      </div>

      <div className={styles.radioRow} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "nowrap" }}>
        <div style={{ display: "flex", gap: "16px" }}>
          <label>
            <input
              type="radio"
              name="sidePanelLinkType"
              style={{ marginTop: "2px" }}
              checked={linkType === "single"}
              onChange={() => setLinkType("single")}
            />
            Single link
          </label>
          <label>
            <input
              type="radio"
              style={{ marginTop: "2px" }}
              name="sidePanelLinkType"
              checked={linkType === "formula"}
              onChange={() => setLinkType("formula")}
            />
            Formula
          </label>
        </div>

        {(linkType === "formula" || linkType === "single") && (
          <div style={{ display: "flex", alignItems: "center", gap: "16px", flexShrink: 0, marginLeft: "auto" }}>
            <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer", fontSize: "14px", fontWeight: "500", color: "#33584E" }}>
              <input
                type="checkbox"
                checked={isBold || isTotal || isSubtotal}
                onChange={(e) => {
                  if (!isTotal && !isSubtotal) {
                    setIsBold(e.target.checked);
                  }
                }}
                style={{ accentColor: "#3AB67D", margin: 0, width: "16px", height: "16px" }}
              />
              Bold Format
            </label>
            <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer", fontSize: "14px", fontWeight: "500", color: "#33584E" }}>
              <input
                type="checkbox"
                checked={isTotal}
                onChange={(e) => handleTotalToggle(e.target.checked)}
                style={{ accentColor: "#3AB67D", margin: 0, width: "16px", height: "16px" }}
              />
              Total
            </label>
            <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer", fontSize: "14px", fontWeight: "500", color: "#33584E" }}>
              <input
                type="checkbox"
                checked={isSubtotal}
                onChange={(e) => handleSubtotalToggle(e.target.checked)}
                style={{ accentColor: "#3AB67D", margin: 0, width: "16px", height: "16px" }}
              />
              Subtotal
            </label>
          </div>
        )}
      </div>

      <div
        className={styles.panelBody}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        {linkType === "formula" && (
          <div style={{
            background: "#f8f9fa",
            border: "1px solid #e2e8f0",
            borderRadius: "10px",
            padding: "16px 20px",
            marginBottom: "20px",
            fontSize: "15px",
            color: "#475569",
            lineHeight: "1.6",
            whiteSpace: "normal",
            wordBreak: "break-word",
            fontWeight: "normal",
            width: "100%",
            boxSizing: "border-box"
          }}>
            Formula = {compileFormulaPreview()}
          </div>
        )}
        {linkType === "single" ? renderSingle() : renderFormula()}
      </div>

      <div className={styles.footer}>
      <button className={styles.cancelBtn} onClick={handleClose}>
        Cancel
      </button>


      <div className={styles.rightActions}>
        {(isPrefilled || elements.length > 0 || selections["s-row"]) && (
          <button
            className={styles.deleteBtn}
            onClick={handleDeleteLink}
            disabled={isDeleting}
          >
            <DeleteIcon className={styles.deleteIcon} />
            <span>Delete Link</span>
          </button>
        )}

        <button
          className={styles.applyBtn}
          onClick={handleApply}
          disabled={isSaving}
        >
          {isSaving ? "Saving..." : isPrefilled ? "Update" : "Apply"}
        </button>
      </div>
      <DeletePopup
        isOpen={deleteConfirm !== null}
        title={deleteConfirm?.title}
        message={deleteConfirm?.message}
        onConfirm={deleteConfirm?.onConfirm}
        onCancel={() => setDeleteConfirm(null)}
      />
    </div>
    </div>
  );
};

export default SidePanel;
